<template>
  <div class="grid-view">
    <div class="main-content">
      <div
        style="height: 140px;justify-content: space-between;display: flex;"
        @click="triggerUpload"
      >
        <div style="width:100%;text-align: center;border:1px solid #BDC3C7">
          <p style="font-size: 24px;">{{ $t('SeaExport.DragUploadTheFileIdentified') }}</p>
          <p>{{ $t('SeaExport.SupportUploadFormat') }}pdf/xls/xlsx/doc/docx/jpg/gif/png/tif/rtf</p>
        </div>
      </div>
      <div class="section grid-wrapper">
        <intelligent-booking-table
          :row-data="rowData"
          tab-type="tabPending"
          config-module="310201"
          @showDetails="(e)=>this.$emit('showDetails',e)"
          @refresh="fetchData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="intelligent-tab-pending"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="queryPageHandler"
        />
      </div>
      <drop-uploader
        ref="dropUploader"
        :action="URL.AIdiscern.importAndAnalyseFile"
        :upload-params="{ source: source, iChannel: '0', pageSource: 'intelligentBook', officeId: $store.getters.currentOfficeId }"
        :accept="['pdf','xls','xlsx','doc','docx','jpg','gif','png','tif', 'msword', 'ms-excel', 'jpeg', 'rtf']"
        :file-format="fileFormat"
        :open-drag="openDrag"
        @upload-end="uploadEnd"
      />
    </div>
  </div>
</template>

<script>
import IntelligentBookingTable from '@/views/cargo/v0/SeaExport/IntelligentBooking/components/IntelligentBookingTable'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import { getLoading } from '@/utils/utilBaseElement'
import { queryIntelligentBookingList } from '@/api/seaExport/intelligentBooking'
import URL from '@/api/urlTranslator'

export default {
  name: 'TabPending',
  components: { DropUploader, IntelligentBookingTable },
  props: {
    activeTabName: {
      type: String,
      default: () => ''
    }, openDrag: {
      type: Boolean,
      default: () => true
    },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      URL,
      fileFormat: null,
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 50,
        status: [0, 1, 2]
      },
      rowData: [],
      uploadParams: {},
      loading: false,
      timer: null
    }
  },
  watch: {
    activeTabName(val, oldVal) {
      if (val && val !== oldVal && val === 'tabPending' && !this.timer) {
        this.fetchData()
      } else {
        this.cleanTimer()
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.cleanTimer()
  },
  methods: {
    init() {
      this.fileFormat = '.pdf,.xls,.xlsx,.doc,.docx,.jpg,.gif,.png,.tif'
      this.fetchData(false)
    },
    fetchData(silent = true) {
      console.log('fetchPending')
      if (!silent) {
        this.loading = getLoading()
      }
      if (this.timer) {
        this.cleanTimer()
      }
      queryIntelligentBookingList(this.searchConditions).then(res => {
        const { data } = res
        this.rowData = data.list
        this.searchConditions.total = Number(data.total)
        this.searchConditions.pageNum = data.pageNum
        this.searchConditions.pageSize = data.pageSize
        this.setTimer()
      }).finally(() => {
        !this.loading || this.loading.close()
      })
    },
    queryPageHandler() {
      this.fetchData(this.searchConditions)
    },
    uploadEnd() {
      this.fetchData(false)
    },
    triggerUpload() {
      this.$refs.dropUploader.triggeFileSelectWindow()
    },
    setTimer() {
      this.timer = setTimeout(() => {
        this.fetchData()
      }, 10000)
    },
    cleanTimer() {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
</script>

<style scoped>

</style>
